import { render, staticRenderFns } from "./ResendRecipientsDialog.vue?vue&type=template&id=7a0267e3&scoped=true"
import script from "./ResendRecipientsDialog.vue?vue&type=script&lang=js"
export * from "./ResendRecipientsDialog.vue?vue&type=script&lang=js"
import style0 from "./ResendRecipientsDialog.vue?vue&type=style&index=0&id=7a0267e3&prod&scoped=true&lang=css"
import style1 from "./ResendRecipientsDialog.vue?vue&type=style&index=1&id=7a0267e3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0267e3",
  null
  
)

export default component.exports